import { Box, Button } from "@mui/material";
import { H4, H3 } from "../components/Typography";
import { FC } from "react";
interface CardProps {
  title: string;
  description: any;
  image: any;
  onPress: any;
}

const StaticCard: FC<CardProps> = ({ title, description, image, onPress }) => {
  return (
    <Box sx={sxStyleBox}>
      <Box component="img" src={image} sx={sxStyleImage} />

      <H4 color="#000000" sx={text}>
        {title}
      </H4>

      <H3 color="#757575" sx={textRow}>
        {description}
      </H3>
      <Button
        onClick={onPress}
        type="submit"
        size="medium"
        sx={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          borderRadius: 2,
          padding: 0.8,
          paddingLeft: 2,
          color: "#fff",
          paddingRight: 2,
          marginTop: -2,
          background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
          fontSize: 12,
          position: "relative",
          bottom: -30,
          width: {
            md: "50%",
            xs: "50%",
          },
          fontFamily: "'Poppins', sans-serif",
          textTransform: "none",
        }}
      >
        Invest Now
      </Button>
    </Box>
  );
};

export default StaticCard;
const sxStyleImage = {
  height: {
    xs: 40,
    sm: "20%",
    md: 50,
  },
  width: {
    xs: 40,
    sm: "20%",
    md: 50,
  },
};
const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 14,
  mt: 1.5,
  mb: 1,
  fontWeight: "600",
};
const textRow = {
  display: "flex",
  fontWeight: "400",
  fontSize: 13,
  width: "100%",
  textAlign: "center",
  fontFamily: "'Poppins', sans-serif",
};

const sxStyleBox = {
  marginRight: {
    md: 2,
    xs: 1,
  },
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  paddingTop: 4,
  paddingBottom: 0,
  backgroundColor: "#fff",
  flexDirection: "column",
  borderRadius: 3,
  padding: 2,
  alignItems: "center",
  mt: {
    xs: 4,
    md: 0,
  },
};
